<template>
  <div
    class="checkbox"
    :class="inlineClass"
  >
    <input
      :id="cbId"
      v-model="model"
      type="checkbox"
      :disabled="disabled"
    >
    <label :for="cbId">
      <slot />
    </label>
  </div>
</template>
<script>
  export default{
    name: 'PCheckbox',
    model: {
      prop: 'checked'
    },
    props: {
      checked: [Array, Boolean],
      disabled: [Boolean, String],
      inline: Boolean
    },
    emits: ['input'],
    data () {
      return {
        cbId: ''
      }
    },
    computed: {
      model: {
        get () {
          return this.checked
        },
        set (check) {
          this.$emit('input', check)
        }
      },
      inlineClass () {
        if (this.inline) {
          return `checkbox-inline`
        }
        return ''
      }
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
    }
  }
</script>
